import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-mark.css';
var getClassNameList = classNames.bind(styles);
var UitkMarkFlag = function (props) {
  var className = props.className,
    description = props.description,
    id = props.id,
    name = props.name;
  var assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/flags/';
  var svgName = "".concat(name === null || name === void 0 ? void 0 : name.toLowerCase(), ".svg");
  var baseCssClass = 'uitk-mark';
  var flagCssClass = 'uitk-mark-flag';
  var cssClassNames = getClassNameList(baseCssClass, className, flagCssClass);
  if (!name) {
    console.error("Uitk-Flag must have \"name\" prop");
  }
  var buildUrl = function () {
    return "".concat(assetsBaseUrl).concat(svgName);
  };
  var alt = description || '';
  return React.createElement("img", {
    className: cssClassNames,
    alt: alt,
    src: buildUrl(),
    id: id
  });
};
UitkMarkFlag.displayName = 'UitkMarkFlag';
export { UitkMarkFlag };